import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

import LogoUrl from '../../../../resources/logo.svg';
import DownloadIconUrl from '../../../../resources/icons/icon-download-black.svg';

import {
  DOWNLOAD_TEXT,
  MENU_DESKTOP_WIDTH,
  PRESENTATION_TEXT,
  LINKS,
  WEBSITE_URL,
  PDF_NAME_HR,
  TEXT_LINKS,
} from '../../../../config';

import ShareButton from './ShareButton';

import styles from '../styles';

class DesktopAppMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentHighlightedItem: null,
      isHover: false,
    }
  }
  /**
   * HANDLE
   */
  handleMouseEnter(evt, params = null) {
    const setState = {
      isHover: true,
    };
    if (params) {
      setState.currentHighlightedItem = params;
    }
    this.setState(setState);
  }

  handleMouseLeave(evt) {
    const { relatedTarget, toElement } = evt.nativeEvent;
    if (relatedTarget) {
      if (relatedTarget.classList.contains('bookmarkButton')) {
        return;
      }
      if (relatedTarget.closest('.subDrawer')) {
        return;
      }
    }
    if (toElement) {
      if (toElement.classList.contains('bookmarkButton')) {
        return;
      }
      if (toElement.closest('.subDrawer')) {
        return;
      }
    }
    this.setState({ isHover: false });
  }

  /**
   * RENDER
   */

  renderText(item) {
    if (!item) return null;
    const { classes } = this.props;
    const sections = [
      { label: 'CLIENT', key: 'client' },
      { label: 'SECTEUR', key: 'secteur' },
      { label: 'MILLÉSIMES', key: 'miles' },
      { label: 'CONCEPT', key: 'concept' },
      { label: 'LIVRABLE', key: 'livrable' },
    ];

    return (
      <div className={classes.textRoot}>
        {sections.map(({ label, key }) => {
          const value = item[key];
          if (!value) return null;

          return (
            <div key={key} className={classes.Menublock}>
              <Typography
                variant="overline"
                component="p"
                className={classes.Menulabel}
              >
                {label}
              </Typography>

              <Typography
                variant={key === 'concept' || key === 'livrable' ? 'body2' : 'body1'}
                className={classes.Menuvalue}
              >
                {value}
              </Typography>
            </div>
          );
        })}
      </div>
    );
  }

  renderVideo(item) {
    if (!item) return null;
    const { classes } = this.props;
    const isAbsolute = /^https?:\/\//i.test(item.url);
    const isGif = item.isGif ?? item.url.toLowerCase().endsWith('.gif');
    const isMp4 = item.isVideo ?? item.url.toLowerCase().endsWith('.mp4');

    let src = item.url;

    // Préfixes pour les assets placés dans /public
    if (!isAbsolute) {
      if (isGif && !src.startsWith('/gifs/')) src = `gifs/${src}`;
      if (isMp4 && !src.startsWith('/videos/')) src = `videos/${src}`;
    }
    return (
      <>
        {isGif ? (
          <img
            src={src}
            alt={item.title || 'Animation'}
            className={classes.gifImage}
          />
        ) : isMp4 ? (
          <video
            src={src}
            controls
            autoPlay
            muted
            loop
            playsInline
            poster={item.poster || undefined} // optionnel
            className={classes.video}
            style={{ maxWidth: '100%', height: 'auto' }}
          >
            Votre navigateur ne supporte pas la vidéo HTML5.
          </video>
        ) : (
          <Typography className={classes.buttonDrawerParagraph}>
            <a
              href={item.url}
              className={classes.mainDrawerHeaderLink}
              target={isAbsolute ? '_blank' : undefined}
              rel={isAbsolute ? 'noreferrer' : undefined}
            >
              {item.title || item.url}
            </a>
          </Typography>
        )}
      </>
    )
  }
  renderMainDrawer() {
    const { classes, fullscreen, fileURL, page } = this.props;
    const item = LINKS[page];
    const item_text = TEXT_LINKS[page];
    return (
      <Drawer
        className={classes.mainDrawer}
        variant="persistent"
        anchor="left"
        open={!fullscreen}
      >
        <Box className={classes.mainDrawerHeader} sx={{ flexGrow: 1 }}>
          <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer">
            <img src={LogoUrl} alt="LUCIOLE" />
          </a>
          {(page >= 1 && page <= 3) && (
            <Typography className={classes.mainDrawerParagraph}>
              {PRESENTATION_TEXT}
            </Typography>
          )}
          {this.renderText(item_text)}
          {this.renderVideo(item)}
        </Box>

        <Stack className={classes.socialList} justifyContent='center' style={{ paddingBottom: '32px' }}>
          <Stack>
            <ShareButton classes={classes} />
            <ListItem key="download" className={classes.listItem} disablePadding>
              <ListItemButton
                onClick={() => {
                  // Event for Downloads stat with analytics
                  // window.gtag('event', 'download_pdf', {
                  //   'event_category': 'Luciole',
                  //   'event_label': 'download_pdf_click'
                  // });
                  const link = document.createElement("a");
                  // link.href = fileURL;
                  link.href = `${window.location.pathname}${PDF_NAME_HR}`;
                  link.download = 'LUCIOLE-Cartes-de-voeux.pdf';
                  link.click();
                  if (window.umami) {
                    window.umami.track('Portfolio Cartes de voeux - Download');
                  }
                }}
              >
                <ListItemIcon>
                  <img className={classes.menuIcon} src={DownloadIconUrl} alt={DOWNLOAD_TEXT} />
                </ListItemIcon>
                <ListItemText className={`${classes.drawerLabel}`} primary={<Typography variant="h4">{DOWNLOAD_TEXT}</Typography>} />
              </ListItemButton>
            </ListItem>
          </Stack>
        </Stack>
      </Drawer>
    );
  }

  render() {
    const { classes, fullscreen } = this.props;
    return (
      <Stack
        className={classes.desktopMenuContainer}
        sx={{ width: fullscreen ? 0 : MENU_DESKTOP_WIDTH }}
        direction="row"
      >
        {this.renderMainDrawer()}
      </Stack>
    );
  }
}

DesktopAppMenu.defaultProps = {
  page: 0,
};

DesktopAppMenu.propTypes = {
  // props
  fullscreen: PropTypes.bool,
  page: PropTypes.number,
  fileURL: PropTypes.string,
  // funcs
  onNavigate: PropTypes.func.isRequired,
};

export default withStyles(styles)(DesktopAppMenu);
